module.exports = __webpack_public_path__ + "img/lg_ring_g_0_1_0@3x.47c76916.png";